import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { AppCard, AppRemixIcon } from "@/layout/AppComponents";
import { UnmountClosed } from "react-collapse/lib/UnmountClosed";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import StateSelect01 from "../CardElements/StateSelect01";
import minions from "../../../../../../minions/minions";
import colors from "../../../../../../constants/colors";
import AppSpinner from "../../../../../components/AppSpinner";
import ProbSevRiskBlock from "../CardElements/ProbSevRisk/ProbSevRiskBlock";
import ExpandedContainer from "../ExpandedTabs/ExpandedContainer";
import CalendarBlock from "../CardElements/CalendarBlock/CalendarBlock";
import GoalStateSelect from "../CardElements/GoalStateSelect";
import IconListBlock from "../CardElements/IconListBlock";
import SecondStatesSelect from "../CardElements/SecondStatesSelect";
import Translator from "../../../../../components/helpers/Translator";
import AccionaResidualImpactProbBlock from "../CardElements/AccionaResidualImpactProb/AccionaResidualImpactProbBlock";
import ApplicableDateBlock from "../CardElements/ApplicableDateBlock";
import CopisaResidualImpactProbRiskBlock from "../CardElements/CopisaResidualImpactProbRisk/CopisaResidualImpactProbRiskBlock";
import HaizeaResidualImpactProbBlock from "../CardElements/HaizeaResidualImpactProb/HaizeaResidualImpactProbBlock";

const PlantObligationDefault = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions,
  );
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge?.permissions,
  );
  const poLevel1 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level1,
  );
  const poLevel2 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level2,
  );
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3,
  );
  const [isOpened, setIsOpened] = useState(false);

  const renderPenaltyRiskBlock = useCallback(() => {
    switch (permissions?.gcl?.module?.penaltyRisk?.type) {
      case "acciona":
        return (
          <>
            {poLevel3 ? (
              <div className="poBlock-impactProb">
                <AccionaResidualImpactProbBlock
                  plantObligation={plantObligationID}
                />
              </div>
            ) : (
              <div className="relative poBlock-init-end">
                <AppSpinner>
                  <AppRemixIcon
                    icon="loader-4"
                    size={30}
                    color={colors.primaryLight}
                  />
                </AppSpinner>
              </div>
            )}
          </>
        );
      case "copisa":
        return (
          <>
            {poLevel3 ? (
              <div className="poBlock-impactProb">
                <CopisaResidualImpactProbRiskBlock
                  plantObligation={plantObligationID}
                />
              </div>
            ) : (
              <div className="relative poBlock-init-end">
                <AppSpinner>
                  <AppRemixIcon
                    icon="loader-4"
                    size={30}
                    color={colors.primaryLight}
                  />
                </AppSpinner>
              </div>
            )}
          </>
        );
      case "haizea":
        return (
          <>
            {poLevel3 ? (
              <div className="poBlock-impactProb">
                <HaizeaResidualImpactProbBlock
                  plantObligation={plantObligationID}
                />
              </div>
            ) : (
              <div className="relative poBlock-init-end">
                <AppSpinner>
                  <AppRemixIcon
                    icon="loader-4"
                    size={30}
                    color={colors.primaryLight}
                  />
                </AppSpinner>
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  }, [permissions, poLevel3, plantObligationID]);

  if (!poLevel1) {
    return (
      <div className="card po-default">
        <div className="card-body" />
      </div>
    );
  }

  return (
    <Container
      $userBridgePermissions={userBridgePermissions}
      $permissions={permissions}
      $border={minions.obligation.stateColor(
        poLevel1[plantObligationID]?.state === -1
          ? 0
          : poLevel1[plantObligationID]?.state,
        poLevel1[plantObligationID]?.customState &&
          auth.customStates[poLevel1[plantObligationID]?.customState],
      )}
    >
      <AppCard bodyClassName="po-default">
        {permissions?.gcl?.module?.plant?.states && (
          <StateSelect01
            className="poBlock-init-end"
            plantObligationID={plantObligationID}
          />
        )}
        <div className="poBlock-obligation pt-0">
          {poLevel2 && poLevel2?.[plantObligationID] ? (
            <h3>
              {poLevel2[plantObligationID]?.obligation?.layouts?.length > 0 ? (
                <span>
                  {poLevel2[plantObligationID]?.obligation.layouts[0]}
                </span>
              ) : (
                <>
                  <span>
                    {poLevel2[plantObligationID]?.obligation.category}
                  </span>{" "}
                  /{" "}
                  <span>
                    {poLevel2[plantObligationID]?.obligation.subcategory}
                  </span>
                  <div className="mt-1">
                    •
                    <span className="ml-2">
                      {poLevel2[plantObligationID]?.obligation.note}
                    </span>
                  </div>
                </>
              )}
            </h3>
          ) : (
            ""
          )}
          <ScrollBlock height="100px">
            {poLevel2?.[plantObligationID]?.obligation?.obligationVersion
              ?.obligation ? (
              <>
                <ApplicableDateBlock
                  plantObligationID={plantObligationID}
                  isH3
                />
                {poLevel2?.[plantObligationID]?.obligation?.hasFormat ? (
                  <div
                    className="pr-2"
                    style={{ minHeight: "100px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        poLevel2?.[plantObligationID]?.obligation
                          ?.obligationVersion?.obligation,
                    }}
                  />
                ) : (
                  <div
                    className="pr-2"
                    style={{ minHeight: "100px", whiteSpace: "pre-line" }}
                  >
                    {
                      poLevel2?.[plantObligationID]?.obligation
                        ?.obligationVersion?.obligation
                    }
                  </div>
                )}
                {poLevel2[plantObligationID]?.obligation.subObligations.map(
                  (so, i) => (
                    <div key={i}>
                      <h3 className="mt-3 mb-0">
                        Nota <b>{so.name}</b>
                      </h3>
                      <div
                        className="pr-2"
                        dangerouslySetInnerHTML={{
                          __html: so.subObligation,
                        }}
                      />
                    </div>
                  ),
                )}
              </>
            ) : (
              ""
            )}
          </ScrollBlock>
        </div>
        {!permissions?.gcl?.module?.plant?.removeNextDateEvidenceBlock && (
          <div className="poBlock-nextDate-evidence">
            <div>
              <h3 className="d-flex align-items-center justify-content-between">
                <span>
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.nextDate"
                  />
                </span>
                <div>
                  {permissions?.gcl?.module?.plant?.calendar?.fullCalendar &&
                  [1, 2].includes(
                    poLevel2?.[plantObligationID]?.obligation?.nextDateType,
                  ) ? (
                    <AppRemixIcon
                      icon="settings-2"
                      title={
                        poLevel2?.[plantObligationID]?.obligation
                          ?.nextDateSettings
                          ? ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="nextDate.well.configured"
                              />,
                            )
                          : ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="nextDate.pending.configure"
                              />,
                            )
                      }
                      color={
                        poLevel2?.[plantObligationID]?.obligation
                          ?.nextDateSettings
                          ? colors.grey400
                          : colors.state2
                      }
                      filled
                      size={14}
                      className="pl-1"
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </h3>
              <ScrollBlock
                height={
                  permissions?.gcl?.module?.plant?.evidences ? "50px" : "112px"
                }
              >
                {poLevel2?.[plantObligationID] ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        poLevel2[plantObligationID]?.obligation
                          ?.obligationVersion?.nextDate,
                    }}
                  />
                ) : (
                  "..."
                )}
              </ScrollBlock>
            </div>
            {permissions?.gcl?.module?.plant?.evidences &&
              (userBridgePermissions?.level !== 2 ||
                userBridgePermissions?.evidences?.read === true) && (
                <div>
                  <h3 className="d-flex align-items-center justify-content-between mb-0">
                    <span>
                      <Translator
                        file="module-legalCompliance"
                        name="evidences"
                      />{" "}
                      {poLevel3?.[plantObligationID] && (
                        <small
                          title={
                            poLevel3?.[plantObligationID]?.lastEvidence
                              ? `${ReactDOMServer.renderToString(
                                  <Translator
                                    file="user"
                                    name="user.obligations.last.evidence"
                                  />,
                                )}: ${
                                  poLevel3?.[plantObligationID]?.lastEvidence
                                }`
                              : ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="module.lc.no-evidence"
                                  />,
                                )
                          }
                        >
                          {poLevel3?.[plantObligationID]?.lastEvidence ? (
                            <span>
                              (
                              <AppRemixIcon
                                icon="draft"
                                color={colors.primary}
                                size={12}
                              />
                              {poLevel3?.[plantObligationID]?.lastEvidence})
                            </span>
                          ) : (
                            "(-)"
                          )}
                        </small>
                      )}
                    </span>
                    <div>
                      {[1, 2, 3].includes(
                        poLevel2?.[plantObligationID]?.obligation?.evidenceType,
                      ) ? (
                        <AppRemixIcon
                          icon={
                            poLevel2?.[plantObligationID]?.obligation
                              ?.evidenceType === 1
                              ? "eye"
                              : poLevel2?.[plantObligationID]?.obligation
                                    ?.evidenceType === 3
                                ? "drag-move"
                                : "folder-open"
                          }
                          title={
                            poLevel2?.[plantObligationID]?.obligation
                              ?.evidenceType === 1
                              ? ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="visual"
                                  />,
                                )
                              : poLevel2?.[plantObligationID]?.obligation
                                    ?.evidenceType === 3
                                ? ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="others"
                                    />,
                                  )
                                : ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="documental"
                                    />,
                                  )
                          }
                          color={colors.primary}
                          size={14}
                          className="pl-1"
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </h3>
                  <ScrollBlock height="50px">
                    {poLevel2?.[plantObligationID] ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            poLevel2[plantObligationID]?.obligation
                              ?.obligationVersion?.evidence,
                        }}
                      />
                    ) : (
                      "..."
                    )}
                  </ScrollBlock>
                </div>
              )}
          </div>
        )}
        {permissions?.gcl?.module?.plant?.calendar && (
          <div className="poBlock-calendar">
            <CalendarBlock plantObligationID={plantObligationID} />
          </div>
        )}
        {permissions?.gcl?.module?.penaltyRisk?.type !== undefined
          ? renderPenaltyRiskBlock()
          : (permissions?.gcl?.module?.plant?.probSevRisk?.probability ||
              permissions?.gcl?.module?.plant?.probSevRisk?.severity ||
              permissions?.gcl?.module?.plant?.probSevRisk?.risk) && (
              <>
                {poLevel3 ? (
                  <div className="poBlock-probSevRisk">
                    <ProbSevRiskBlock plantObligation={plantObligationID} />
                  </div>
                ) : (
                  <div className="relative poBlock-init-end">
                    <AppSpinner>
                      <AppRemixIcon
                        icon="loader-4"
                        size={30}
                        color={colors.primaryLight}
                      />
                    </AppSpinner>
                  </div>
                )}
              </>
            )}
        <div className="poBlock-icons">
          <div className="icon-grid">
            {poLevel3 && (
              <IconListBlock plantObligationID={plantObligationID} />
            )}
          </div>
          <div
            className="hex-block"
            data-assign={plantObligationID}
            title={`CODE ${poLevel2?.[plantObligationID]?.obligation?.hex}`}
          >
            <small>CODE</small>
            <br />
            {poLevel2?.[plantObligationID]?.obligation?.hex}
          </div>
        </div>
        {permissions?.gcl?.module?.plant?.states?.secondStates &&
          userBridgePermissions?.level === 0 && (
            <SecondStatesSelect
              className="poBlock-init-end"
              plantObligationID={plantObligationID}
            />
          )}
        {permissions?.gcl?.module?.plant?.states?.goalStates && (
          <GoalStateSelect
            className="poBlock-init-end"
            plantObligationID={plantObligationID}
          />
        )}
        <div
          className="poBlock-init-end bg-primary pointer"
          onClick={() => setIsOpened(!isOpened)}
        >
          <AppRemixIcon icon={isOpened ? "subtract" : "add"} color="white" />
        </div>
        <div />
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <ExpandedContainer plantObligationID={plantObligationID} />
      </UnmountClosed>
    </Container>
  );
};

export default PlantObligationDefault;

const Container = styled.div`
  border-radius: 3px;
  .po-default{
    padding: 2px;
    height: 160px;
    display: grid;
    grid-template-columns: 
      ${(props) =>
        props.$permissions?.gcl?.module?.plant?.states && "40px"} //State
      1fr //Obligation
      ${(props) =>
        !props.$permissions?.gcl?.module?.plant?.removeNextDateEvidenceBlock &&
        "190px"}//Periodicity/Evidence
      ${(props) =>
        props.$permissions?.gcl?.module?.plant?.calendar && "150px"} //Calendar
      ${(props) =>
        (props.$permissions?.gcl?.module?.plant?.probSevRisk?.probability ||
          props.$permissions?.gcl?.module?.plant?.probSevRisk?.severity ||
          props.$permissions?.gcl?.module?.plant?.probSevRisk?.risk) &&
        (!props.$permissions?.gcl?.module?.accionaPenaltyRiskCalculation ||
          props.$permissions?.gcl?.module?.accionaPenaltyRiskCalculation ===
            false) &&
        "46px"} //Prob,Sev,Risk
      ${(props) =>
        props.$permissions?.gcl?.module?.accionaPenaltyRiskCalculation &&
        "46px"} //AccionaResidualImpact
      46px //IconList
      ${(props) =>
        props.$permissions?.gcl?.module?.plant?.states?.secondStates &&
        props.$userBridgePermissions?.level === 0 &&
        "40px"} //SecondStates
      ${(props) =>
        props.$permissions?.gcl?.module?.plant?.states?.goalStates &&
        "40px"} //Goals
      40px;//Expand
    overflow: hidden;
    border: 1px solid ${(props) => props.$border};
    h3{
      font-weight: normal;
      color: ${colors.primaryLight}
    }
    &>div{
     border-right: 1px solid ${colors.grey300};
    }
    &>.poBlock-init-end{
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 30px;
      padding: 0;
      height: 154px;
    }
    &>.poBlock-obligation{
      padding: 10px;
      overflow: hidden;
      border-radius: 2px;
      font-size: 13px;
      border-right: 1px solid $gray-300;
      
    }
    &>.poBlock-nextDate-evidence{
      padding: 10px;
      border-right: 1px solid $gray-300;
      font-size: 11px;
      // ${(props) =>
        props.$permissions?.gcl?.module?.plant?.evidences
          ? "&>div{height: 70px;}"
          : "&>div{height: 100%;}"} // NextDate height
    }
    &>.poBlock-calendar{
      padding: 10px;
    }
    &>.poBlock-icons{
      height: 90%;
      display: grid;
      grid-template-rows: 1fr 30px;
      .icon-grid{
        padding: 3px;
        display: grid;
        grid-template-columns: 20px 20px;
        grid-template-rows: 20px 20px 20px 20px 20px 20px;
        height: 70%;
        &>i{
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .hex-block{
        font-size: 10px;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
        color: ${colors.primaryLight};
        //margin-top: 16px;
      }
      
    }
    &>.poBlock-probSevRisk{
      max-height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      color: ${colors.primary};
      span{
        padding: 10px 0;
      }
    }
    &>.poBlock-impactProb{
      max-height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      color: ${colors.primary};
      justify-content: center;
      span{
        padding: 10px 0;
      }
    }
  }
  h3{
    font-size: 13px;
    color: $primary;
    margin: 0 0 6px 0;
    font-weight: bold;
  }
  h4{
    font-size: 10px;
    color: $primary;
    text-transform: uppercase;
  }
}
`;

const ScrollBlock = styled.div`
  height: ${(props) => props.height ?? "340px"};
  padding-right: 10px;
  overflow-x: auto;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
